var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFfvLevel4 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#009FE3",
  d: "M8.312 2c5.42 7.8-3.898 13-3.898 13h8.73c3.706 0 6.498-2.715 6.498-6.498C19.642 4.715 16.818 2 13.145 2H8.312Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.19 6.89c-.26.34-.537.71-.83 1.11-.293.4-.54.81-.74 1.23h1.57V6.89Zm1.46-1.82v4.16h.74v1.22h-.74V12h-1.46v-1.55H11.2V9.36c.147-.293.33-.623.55-.99a19.004 19.004 0 0 1 1.59-2.29c.3-.373.6-.71.9-1.01h1.41Z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ffv-level-4_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#ffv-level-4_svg__b)",
  d: "M4.709 8.612C3.81 3.482.082 2 .082 2a16.41 16.41 0 0 1 .743 10.694c1.963-1.33 3.16-2.77 3.884-4.082Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ffv-level-4_svg__c)",
  d: "M5.782 4.238s.26 1.967-1.069 4.374c.18 1.028.248 2.197.147 3.531.44-.422.871-.894 1.252-1.449 2.838-4.14-.33-6.456-.33-6.456Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ffv-level-4_svg__d)",
  d: "M.825 12.693A13.694 13.694 0 0 1 0 15c1.554-.628 3.32-1.385 4.855-2.852-2.113.619-4.03.545-4.03.545Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ffv-level-4_svg__e)",
  d: "M4.855 12.143c.101-1.334.032-2.508-.146-3.53-.725 1.31-1.921 2.75-3.884 4.08 0 0 1.917.074 4.03-.55Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "ffv-level-4_svg__b",
  x1: -0.902,
  x2: 3.97,
  y1: 2.348,
  y2: 12.786,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#82D0F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.176,
  stopColor: "#00A7E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.602,
  stopColor: "#0069B4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005CA9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ffv-level-4_svg__c",
  x1: 7.403,
  x2: 3.417,
  y1: 4.845,
  y2: 12.134,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A1DAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.005,
  stopColor: "#A1DAF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.454,
  stopColor: "#40C0F0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.465,
  stopColor: "#3ABEEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.706,
  stopColor: "#009EDD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.89,
  stopColor: "#008CD2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.995,
  stopColor: "#0086CD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0086CD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ffv-level-4_svg__d",
  x1: -0.223,
  x2: 4.927,
  y1: 14.044,
  y2: 12.441,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0087CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#004A9A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ffv-level-4_svg__e",
  x1: 0.828,
  x2: 5.019,
  y1: 10.749,
  y2: 10.565,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00438B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.005,
  stopColor: "#00438B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.97,
  stopColor: "#23185A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#18073A"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ffv-level-4_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 2h7.29v13H0z"
})))));
export { SvgFfvLevel4 as ReactComponent };
export default "data:image/svg+xml;base64,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";